import React, { useEffect, useState } from "react";
import $ from "jquery";
import { useDispatch } from "react-redux";
import differenceInYears from "date-fns/differenceInYears";

import solidaire from "../../../../../../assets/images/svg/004-B-solidaire.svg";

import * as loadings from "../../../../../../constants/loadings/relocationDeclaration";
import { updateRelocationDeclaration } from "../../../../../../actions/events-api";

export const Step3 = ({ userId, relocationDeclaration,  isLoading, setOnboardingStep, getDeclaration }) => {
	const dispatch = useDispatch();

	let lessThan20Children = relocationDeclaration.children.filter((c) => differenceInYears(new Date(), new Date(c.birthDate)) < 20);

	let CivilStatus = {
		Single: 1,
		Married: 2,
		Divorced: 3,
		Widowed: 4,
		FreeUnion: 5,
		CivilUnion: 6,
	};

	const aides = {
		familySupportAllowance: {
			id: "familySupportAllowance",
			name: "Allocation de soutien familial",
			title:
				"C'est une aide valable pour les personnes vivant seules avec un enfant de moins de 20 ans. Pour avoir droit à l'ASF, vous devez remplir l'ensemble des conditions suivantes : vivre seul(e), résider en France, avoir au moins 1 enfant à charge pour lequel l'autre parent ne participe plus à l'entretien depuis au moins 1 mois ou vous verse une pension alimentaire inférieure à 195,85 €.",
			icon: solidaire,
			valid: lessThan20Children.length > 0 && relocationDeclaration.civilStatus !== CivilStatus.Married && relocationDeclaration.civilStatus !== CivilStatus.FreeUnion && relocationDeclaration.civilStatus !== CivilStatus.CivilUnion,
		},
		housingAssistance: {
			id: "housingAssistance",
			name: "Aides au logement",
			title: "Si vous payez un loyer ou remboursez un prêt et que vos ressources sont modestes, vous pouvez bénéficier de l'une des trois aides au logement proposées par la CAF.",
			icon: solidaire,
			valid: relocationDeclaration.newAddress.contractType !== 3,
		},
		cafRelocationIncentive: {
			id: "cafRelocationIncentive",
			name: "Prime au déménagement CAF",
			title:
				"La prime de déménagement est une aide verséé par la Caf pour compenser cette dépense si votre déménagement est dû à l’agrandissement de votre foyer. Pour en bénéficier, vous devez avoir au moins 3 enfants à charge, avoir déménagé entre le 1er jour du mois civil qui suit la fin de votre 3ème mois de grossesse et le dernier jour du mois précédent le 2ème anniversaire de votre dernier enfant, avoir droit à l’Apl (aide personnalisée au logement) ou à l’Alf (allocation logement à caractère familial) pour votre nouveau logement.",
			icon: solidaire,
			valid:
				relocationDeclaration.children.filter((child) => {
					return child.isDependent;
				}).length > 2,
		},
		solidarityHousingFund: {
			id: "solidarityHousingFund",
			name: "Fond de solidarité pour le logement (FSL)",
			title:
				"Le FSL est un dispositif mis en place pour aider les personnes aux ressources modestes à accéder et à se maintenir dans un logement (locations, sous-locations, résidence sociale), adapté à leur situation familiale et financière. Cette aide peut vous être attribuée sous conditions de ressources. Pour en bénéficier, vous devez vous rapprocher d'une assistante sociale qui se chargera de votre demande d'aide.",
			icon: solidaire,
			valid: true,
		},
		mobiliPassAssistance: {
			id: "mobiliPassAssistance",
			name: "Aide Mobili-pass",
			title:
				"Vous pouvez en bénéficier si vous êtes salarié d’une entreprise (non agricole) employant au moins 10 personnes ; vous déménagez pour des raisons professionnelles (embauche, mutation, déménagement de l’entreprise) sur le territoire français ; une distance d’au moins 70 km sépare votre ancienne résidence de votre nouvelle résidence ou le temps de transport est supérieur à 1h15 entre votre ancienne résidence et votre lieu de travail. Notez que cette condition ne s’applique pas dans le cas d’un déménagement de votre entreprise ou dans le cadre d’une procédure collective.",
			icon: solidaire,
			valid: relocationDeclaration.reason == 1,
		},
		agriMobilityAssistance: {
			id: "agriMobilityAssistance",
			name: "Aide Agri Mobilité",
			title: "Si vous êtes salarié du secteur agricole, l'aide Agri-mobilité peut vous être proposée pour accompagner votre mobilité professionnelle.",
			icon: solidaire,
			valid: relocationDeclaration.professionalSituation.includes("Employed") && relocationDeclaration.reason == 1,
		},
		mobiliJeuneAssistance: {
			id: "mobiliJeuneAssistance",
			name: "Aide Mobili-jeune",
			title:
				"Vous pouvez en bénéficier si : vous avez moins de 30 ans ; vous êtes salarié d’une entreprise du secteur privé non agricole ; vous êtes en contrat d’apprentissage ou de professionnalisation ; vous n'avez pas de dossier MOBILI-JEUNE® en cours chez Action Logement ou votre précédent dossier MOBILI-JEUNE® est terminé ; votre salaire mensuel brut est inférieur ou égal à 80% du SMIC ; votre logement actuel correspond à un rapprochement de votre lieu de travail et doit être situé à plus de 70 km de votre ancienne adresse ou d'un temps de trajet supérieur à 40 minutes OU vous occupez 2 logements sur la même période et justifiez d'une double charge de loyer ; votre date d’effet du bail doit être 3 mois avant ou 3 mois après la date d'exécution du contrat d'alternance ; votre demande d'aide doit être réalisée 3 mois avant ou 3 mois après le début de la date d'exécution du contrat d'alternance.",
			icon: solidaire,
			valid: relocationDeclaration.newAddress.contractType === 3 && relocationDeclaration.professionalSituation.includes("Employed") && relocationDeclaration.professionalSituation.includes("Student"),
		},
		statePersonnelInstallationAssistance: {
			id: "statePersonnelInstallationAssistance",
			name: "Aide à l’installation des personnels de l’État (AIP)",
			title: "L’aide à l’installation des personnels de l’État (AIP) est réservée aux agents (fonctionnaire stagiaire ou titulaire, agent contractuel…) ayant récemment intégré la fonction publique de l’État, exercant la majeure partie de leurs fonctions en quartiers prioritaires de la politique de la ville.",
			icon: solidaire,
			valid: relocationDeclaration.professionalSituation.includes("Employed"),
		},
		retirementRelocationAssistance: {
			id: "retirementRelocationAssistance",
			name: "Aide au déménagement retraite",
			title: "Si vous êtes retraités, vous pouvez demander une aide au déménagement à votre caisse de retraite. Les conditions sont variables selon la caisse de retraite.",
			icon: solidaire,
			valid: relocationDeclaration.professionalSituation.includes("Retired"),
		},
		parcoursupMobilityAssistance: {
			id: "parcoursupMobilityAssistance",
			name: "Aide à la mobilité des bacheliers",
			title:
				"C'est une aide financière de 500 € pour les futurs étudiants boursiers qui souhaitent s'inscrire dans une formation située hors de leur académie de résidence. Les conditions à remplir :  être bénéficiaire d'une bourse de lycée ; être inscrit sur Parcoursup cette année et avoir confirmé au moins un vœu en-dehors de son académie de résidence ; avoir accepté définitivement une proposition d'admission (OUI ou OUI-SI) pour un vœu confirmé hors de son académie de résidence",
			icon: solidaire,
			valid: relocationDeclaration.professionalSituation.includes("Student"),
		},
		masterMobilityAssistance: {
			id: "masterMobilityAssistance",
			name: "Aide mobilité Master 1",
			title:
				"C'est une aide financière de 1 000 € pour les étudiants boursiers s'inscrivant en 1ère année de Master dans une académie différente de celle où la licence a été obtenu. Pour en bénéficier, vous devez, à la rentrée universitaire, remplir l’ensemble des conditions suivantes : - Avoir obtenu une licence l'année précédente. Attention, l'obtention d'une licence professionnelle ne vous permet pas de bénéficier de l'aide. - Vous inscrire pour la 1re fois en 1re année de Master - Bénéficier de la bourse sur critères sociaux ou d'une allocation annuelle spécifique pour étudiant en difficulté - Vous inscrire dans une université d'une région différente de celle où vous avez obtenu votre licence",
			icon: solidaire,
			valid: relocationDeclaration.professionalSituation.includes("Student"),
		},
		mdphRelocationIncentive: {
			id: "mdphRelocationIncentive",
			name: "Prime au déménagement MDPH",
			title:
				"La prime au déménagement est versée pour les personnes en situation de handicap éligibles à la PCH. Les frais de déménagement peuvent être intégrés à votre PCH. Le coût d’un déménagement peut être couvert dans le cadre d’une PCH déménagement si l’aménagement du logement occupé s’avère trop coûteux ou techniquement impossible ou si la personne emménage dans un logement adapté.",
			icon: solidaire,
			valid: true,
		},
	};

	const [selectedAllocations, setSelectedAllocations] = useState({
		items: relocationDeclaration.allocations,
	});

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip({ boundary: "window" });
	}, []);

	return (
		<article className="view-calc pt-3 mb-auto">
			<hr className="d-none" />
			<div className="auto-view scroll-auto pb-3 pb-lg-0">
				<div className="container-fluid">
					<h1 className="text-primary font-weight-bolder mt-2 mb-3">Aides et Allocations au déménagement</h1>
					<p className="h2 o-50 mb-gutter ls-n1 mt-n1">Sélectionnez les aides et allocations que vous souhaitez pour l’édition des documents</p>
					<section className="block">
						<form className="grid grid-sm-narrow grid-xl-4 py-sm">
							{Object.values(aides).map((aid, index) => {
								if (aid.valid === false) return "";

								return (
									<div
										key={index}
										className={"card p-2 text-center picker-card h-fixed" + (selectedAllocations.items.indexOf(aid.id) > -1 ? " active" : "")}
										data-toggle="tooltip"
										data-placement="bottom"
										data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-1 fs-xl-2"></div></div>'
										title={aid.title}
										onClick={(e) => {
											if (selectedAllocations.items.indexOf(aid.id) > -1) {
												setSelectedAllocations({ ...selectedAllocations, items: selectedAllocations.items.filter((i) => i !== aid.id) });
											} else {
												setSelectedAllocations({ ...selectedAllocations, items: selectedAllocations.items.concat(aid.id) });
											}
										}}>
										<img className="img-fluid mx-auto mt-auto mb-sm h-6 py-1" src={aid.icon} alt={aid.name} />
										<h2 className="h6 text-uppercase font-weight-bolder mb-auto">
											{aid.name.split("\n").map((p, idx) => {
												return (
													<div key={idx}>
														{p}
														<br />
													</div>
												);
											})}
										</h2>
									</div>
								);
							})}
						</form>
					</section>
				</div>
				<div className="container-fluid">
					<footer className="d-block mt-auto mb-sm text-right w-100">
						<button
							className="btn btn-faded px-md-gutter mr-3"
							onClick={() => {
								setOnboardingStep(2);
							}}>
							Retour
						</button>
						{isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) ? (
							<button type="button" className="btn btn-info loading-btn px-md-gutter px-4 show">
								Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						) : (
							<button
								type="button"
								className={"btn btn-info loading-btn px-md-gutter px-4"}
								onClick={async (event) => {
									event.preventDefault();
									dispatch(updateRelocationDeclaration(userId, { ...relocationDeclaration, onBoardingStep: 4, allocations: selectedAllocations.items })).then(() => {
										getDeclaration();
										setOnboardingStep(4);
									});
								}}>
								Étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						)}
					</footer>
				</div>
			</div>
		</article>
	);
};
